var _CommandHandler_actions, _CommandHandler_actionStorage, _CommandHandler_nodesIgnoreList, _CommandHandler_filteredActionsCarousel, _CommandHandler_view, _CommandHandler_anchor, _CommandHandler_range, _CommandHandler_filterText, _CommandHandler_popupCloser, _CommandHandler_menuProps, _CommandHandler_menuRenderItem;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { logger } from '../../..//logger';
import { AutocompletePopupCloser } from '../../..//utils/autocomplete-popup';
import { ArrayCarousel } from '../../..//utils/carousel';
import { isFunction } from '../../../lodash';
import { AutocompleteActionKind, closeAutocomplete, } from '../Autocomplete';
import { getReactRendererFromState } from '../ReactRenderer';
import { render } from './component';
import { findDecoElem } from './utils';
export class CommandHandler {
    constructor({ actions, storage, nodesIgnoreList = [] }) {
        _CommandHandler_actions.set(this, void 0);
        _CommandHandler_actionStorage.set(this, void 0);
        _CommandHandler_nodesIgnoreList.set(this, void 0);
        _CommandHandler_filteredActionsCarousel.set(this, void 0);
        _CommandHandler_view.set(this, void 0);
        _CommandHandler_anchor.set(this, void 0);
        _CommandHandler_range.set(this, void 0);
        _CommandHandler_filterText.set(this, void 0);
        _CommandHandler_popupCloser.set(this, void 0);
        _CommandHandler_menuProps.set(this, void 0);
        _CommandHandler_menuRenderItem.set(this, void 0);
        this.onItemClick = (index) => {
            var _a;
            if (__classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f")) {
                __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f").currentIndex = index;
                this.select();
            }
            (_a = __classPrivateFieldGet(this, _CommandHandler_view, "f")) === null || _a === void 0 ? void 0 : _a.focus();
        };
        __classPrivateFieldSet(this, _CommandHandler_actions, actions, "f");
        __classPrivateFieldSet(this, _CommandHandler_actionStorage, storage, "f");
        __classPrivateFieldSet(this, _CommandHandler_nodesIgnoreList, nodesIgnoreList, "f");
    }
    onOpen(action) {
        this.findAnchor();
        if (!__classPrivateFieldGet(this, _CommandHandler_anchor, "f") || this.shouldIgnore(action)) {
            this.closeAutocomplete(action.view);
            return true;
        }
        __classPrivateFieldSet(this, _CommandHandler_popupCloser, new AutocompletePopupCloser(action.view), "f");
        this.updateState(action);
        this.filterActions();
        this.render();
        return true;
    }
    onFilter(action) {
        var _a, _b;
        if (this.shouldIgnore(action) || ((_a = action.filter) === null || _a === void 0 ? void 0 : _a.endsWith('  '))) {
            this.closeAutocomplete(action.view);
            return true;
        }
        this.updateState(action);
        __classPrivateFieldSet(this, _CommandHandler_filterText, (_b = action.filter) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase(), "f");
        const needToClose = this.filterActions();
        this.render();
        if (needToClose) {
            this.closeAutocomplete(action.view);
        }
        return true;
    }
    onArrow(action) {
        if (this.shouldIgnore(action)) {
            closeAutocomplete(action.view);
            return true;
        }
        this.updateState(action);
        if (!__classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f"))
            return false;
        switch (action.kind) {
            case AutocompleteActionKind.up: {
                __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f").prev();
                break;
            }
            case AutocompleteActionKind.down: {
                __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f").next();
                break;
            }
            default:
                return false;
        }
        this.render();
        return true;
    }
    onEnter(action) {
        if (this.shouldIgnore(action)) {
            closeAutocomplete(action.view);
            return true;
        }
        this.updateState(action);
        this.select();
        return true;
    }
    onClose(action) {
        this.updateState(action);
        this.clear();
        return true;
    }
    onDestroy() {
        this.clear();
    }
    closeAutocomplete(view) {
        setTimeout(() => {
            closeAutocomplete(view);
        });
    }
    shouldIgnore(action) {
        const parentType = action.view.state.doc.resolve(action.range.from).parent.type;
        return (parentType.spec.commandMenu === false || __classPrivateFieldGet(this, _CommandHandler_nodesIgnoreList, "f").includes(parentType.name));
    }
    select() {
        var _a;
        if (!__classPrivateFieldGet(this, _CommandHandler_view, "f") || !__classPrivateFieldGet(this, _CommandHandler_range, "f"))
            return;
        const action = (_a = __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f")) === null || _a === void 0 ? void 0 : _a.currentItem;
        if (!action)
            return;
        const view = __classPrivateFieldGet(this, _CommandHandler_view, "f");
        const range = __classPrivateFieldGet(this, _CommandHandler_range, "f");
        view.dispatch(view.state.tr.deleteRange(range.from, range.to).scrollIntoView());
        action.exec(__classPrivateFieldGet(this, _CommandHandler_actionStorage, "f"));
        view.focus();
        logger.action({ mode: 'wysiwyg', source: 'command-menu', action: action.id });
    }
    filterActions() {
        var _a;
        const currentItem = (_a = __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f")) === null || _a === void 0 ? void 0 : _a.currentItem;
        const inputText = __classPrivateFieldGet(this, _CommandHandler_filterText, "f");
        const enabledActions = __classPrivateFieldGet(this, _CommandHandler_actions, "f").filter((action) => action.isEnable(__classPrivateFieldGet(this, _CommandHandler_actionStorage, "f")));
        let filteredActions = enabledActions;
        let needToClose = false;
        if (inputText) {
            filteredActions = filterActions(enabledActions, inputText);
            needToClose = !filteredActions.length && needToHide(enabledActions, inputText);
        }
        __classPrivateFieldSet(this, _CommandHandler_filteredActionsCarousel, new ArrayCarousel(filteredActions), "f");
        if (currentItem) {
            const newIndex = __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f").array.findIndex((item) => item === currentItem);
            if (newIndex !== -1) {
                __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f").currentIndex = newIndex;
            }
        }
        return needToClose;
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        this.findAnchor();
        const viewItems = (_b = (_a = __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f")) === null || _a === void 0 ? void 0 : _a.array) !== null && _b !== void 0 ? _b : [];
        __classPrivateFieldSet(this, _CommandHandler_menuProps, {
            anchor: __classPrivateFieldGet(this, _CommandHandler_anchor, "f"),
            currentIndex: (_c = __classPrivateFieldGet(this, _CommandHandler_filteredActionsCarousel, "f")) === null || _c === void 0 ? void 0 : _c.currentIndex,
            items: viewItems,
            onClick: this.onItemClick,
            onEscapeKeyDown: (_d = __classPrivateFieldGet(this, _CommandHandler_popupCloser, "f")) === null || _d === void 0 ? void 0 : _d.popupEscapeKeyHandler,
            onOutsideClick: (_e = __classPrivateFieldGet(this, _CommandHandler_popupCloser, "f")) === null || _e === void 0 ? void 0 : _e.popupOutsideClickHandler,
        }, "f");
        __classPrivateFieldSet(this, _CommandHandler_menuRenderItem, (_f = __classPrivateFieldGet(this, _CommandHandler_menuRenderItem, "f")) !== null && _f !== void 0 ? _f : this.createMenuRenderItem(), "f");
        __classPrivateFieldGet(this, _CommandHandler_menuRenderItem, "f").rerender();
    }
    updateState({ view, range }) {
        __classPrivateFieldSet(this, _CommandHandler_view, view, "f");
        __classPrivateFieldSet(this, _CommandHandler_range, range, "f");
    }
    clear() {
        var _a, _b;
        __classPrivateFieldSet(this, _CommandHandler_view, undefined, "f");
        __classPrivateFieldSet(this, _CommandHandler_range, undefined, "f");
        __classPrivateFieldSet(this, _CommandHandler_anchor, undefined, "f");
        __classPrivateFieldSet(this, _CommandHandler_filterText, undefined, "f");
        __classPrivateFieldSet(this, _CommandHandler_filteredActionsCarousel, undefined, "f");
        (_a = __classPrivateFieldGet(this, _CommandHandler_popupCloser, "f")) === null || _a === void 0 ? void 0 : _a.cancelTimer();
        __classPrivateFieldSet(this, _CommandHandler_popupCloser, undefined, "f");
        __classPrivateFieldSet(this, _CommandHandler_menuProps, undefined, "f");
        (_b = __classPrivateFieldGet(this, _CommandHandler_menuRenderItem, "f")) === null || _b === void 0 ? void 0 : _b.remove();
        __classPrivateFieldSet(this, _CommandHandler_menuRenderItem, undefined, "f");
    }
    createMenuRenderItem() {
        return getReactRendererFromState(__classPrivateFieldGet(this, _CommandHandler_view, "f").state).createItem('command_menu', () => __classPrivateFieldGet(this, _CommandHandler_menuProps, "f") ? render(__classPrivateFieldGet(this, _CommandHandler_menuProps, "f")) : null);
    }
    findAnchor() {
        var _a;
        __classPrivateFieldSet(this, _CommandHandler_anchor, findDecoElem((_a = __classPrivateFieldGet(this, _CommandHandler_view, "f")) === null || _a === void 0 ? void 0 : _a.dom), "f");
    }
}
_CommandHandler_actions = new WeakMap(), _CommandHandler_actionStorage = new WeakMap(), _CommandHandler_nodesIgnoreList = new WeakMap(), _CommandHandler_filteredActionsCarousel = new WeakMap(), _CommandHandler_view = new WeakMap(), _CommandHandler_anchor = new WeakMap(), _CommandHandler_range = new WeakMap(), _CommandHandler_filterText = new WeakMap(), _CommandHandler_popupCloser = new WeakMap(), _CommandHandler_menuProps = new WeakMap(), _CommandHandler_menuRenderItem = new WeakMap();
function filterActions(actions, text) {
    return actions.filter((action) => action.id.toLowerCase().includes(text) ||
        (isFunction(action.title) ? action.title() : action.title).toLowerCase().includes(text));
}
const CHARS_TO_HIDE = 4;
function needToHide(actions, text) {
    let iter = 1;
    do {
        const prevInput = text.slice(0, text.length - iter);
        const prevActions = filterActions(actions, prevInput);
        if (prevActions.length)
            break;
        iter++;
    } while (iter < text.length && iter < CHARS_TO_HIDE);
    return iter >= CHARS_TO_HIDE;
}
